import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditSearchpage extends Component {

    state = {
        searchpage: this.props.searchpage,
    }

    onSave = () => {
        this.props.onSave(this.state)
    }

    render() {
        const { searchpage = '' } = this.state

        return (
            <Modal
                narrow
                extraClassName="EditSearchpage"
                onCancel={this.props.onClose}
                onSave={this.onSave}
                saveText="Save"
                mode="edit"
                title="Searchpage">
                <Form>
                    <div>
                        <input
                            type="url"
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            spellCheck="false"
                            placeholder="Search URL"
                            value={searchpage}
                            onChange={e => this.setState({ searchpage: e.target.value })} />
                    </div>
                </Form>
            </Modal>
        )
    }
}

export default EditSearchpage



// WEBPACK FOOTER //
// ./src/components/LBUs/EditSearchpage.js